module.exports = __webpack_public_path__ + "static/media/crossNew.67e29f67.svg";